export default __webpack_public_path__ + "static/store-galaxy.th-de55dc301288e6f3a63dce6b9b250fd1.png";